// 2026-10-27 coder(lq): 全局选项表达安全上限，系统选项表达本系统配置；只用于展示，不改写后端策略或实际鉴权。
export const GLOBAL_POLICY_MODES = { OFF: '关闭', AUDIT: '全部仅观察', ENFORCE: '按各系统设置执行' }
export const POLICY_MODES = { OFF: '关闭', AUDIT: '仅观察', ENFORCE: '正式拦截', MIXED: '混合模式（保留原配置）' }

export function scopeEffect(policy, selection) {
    if (!policy.enabled || policy.gatewayMode === 'OFF') return { label: '不启用校验', reason: '权限校验总开关未运行。' }
    if (selection.mode === 'OFF') return { label: '不启用校验', reason: '本系统已关闭。' }
    if (policy.gatewayMode === 'AUDIT') return { label: '仅观察', reason: '全局已选择“全部仅观察”，本系统的正式拦截设置暂不执行；切换全局模式不会丢失系统设置。' }
    if (selection.mode === 'MIXED') return { label: '按原菜单分别执行', reason: '已有菜单中包含观察和拦截两种设置；修改本系统前需先选择统一方式。' }
    return selection.mode === 'AUDIT'
        ? { label: '仅观察', reason: '全局允许按各系统设置执行，本系统设置为仅观察。' }
        : { label: '正式拦截', reason: '全局允许按各系统设置执行，本系统设置为正式拦截；仅作用于已勾选菜单的已映射接口。' }
}
